<template>
  <div class="container">
    <div v-if="views.length > 0">
      <div class="view" v-for="view in views" :key="view.id">
        <div class="split">
          <div>
            <router-link tag="h2" class="clickable" :to="'/view/'+view.uuid" >#{{view.uuid}}</router-link>
            <h3>Devices</h3>
            <div class="devices">
              <div v-if="view.devices != ''">
                <span class="btn" title="Remove device from view" v-for="(device, index) in view.devices.split(',')" :key="index" v-on:click="removeDeviceFromView.view = view.uuid, removeDeviceFromView.device = device">{{device}}</span>
              </div>
              <span class="btn" title="Add device to view" v-on:click="addDeviceTo=view.uuid">+</span>
            </div>
          </div>
          <div class="button-line">
            <div
              v-if="view.public"
              class="btn green"
              v-on:click="view.public=0; saveView(view)"
              title="Make private"
            >Public</div>
            <div v-else class="btn yellow" v-on:click="view.public=1; saveView(view)" title="Make public">Private</div>
            <div class="btn sm red" v-on:click="deleteView = view">Delete</div>
          </div>
        </div>
      </div>
    </div>
    <p v-else class="no-result">No views found</p>
    <div class="addView" v-on:click="/*createView = 1*/createViewFunction('New view')">
      <p>Create a view</p>
    </div>




    <div class="modal" v-if="addDeviceTo != -1">
      <div class="modal-body">
        <h2>Add device to view</h2>
        <p>Select a device form the list to be added to the view #{{addDeviceTo}}.</p>
        <select class="btn" v-model="deviceToBeAdded">
          <option
            v-for="(device, index) in this.$store.state.stats.devices"
            :key="index"
            :value="device.id"
          >{{device.name}}</option>
        </select>
        <div class="action-panel">
          <div class="btn" v-on:click="addDeviceTo=-1">Cancel</div>
          <div class="btn main" v-on:click="addDeviceToView()">Add</div>
        </div>
      </div>
    </div>

    <div class="modal" v-if="removeDeviceFromView.view != -1">
      <div class="modal-body">
        <h2>Remove a device from view</h2>
        <p>Are you sure you wish to remove det device {{removeDeviceFromView.device}} from the view #{{removeDeviceFromView.view}}?</p>
        <div class="action-panel">
          <div class="btn" v-on:click="removeDeviceFromView.view = -1, removeDeviceFromView.device = -1">Cancel</div>
          <div class="btn red" v-on:click="removeDeviceFromViewFunction()">Remove</div>
        </div>
      </div>
    </div>
    <!-- Delete view -->
    <div class="modal" v-if="deleteView != null">
      <div class="modal-body">
        <h2>Delete view</h2>
        <p>Are you sure you wish to delete the view #{{deleteView.uuid}}?</p>
        <p>This action cannot be undone.</p>
        <div class="action-panel">
          <div class="btn" v-on:click="deleteView = null">Cancel</div>
          <div class="btn red" v-on:click="deleteViewFunction(deleteView.uuid)">Delete</div>
        </div>
      </div>
    </div>
    <!-- Create view -->
    <div class="modal" v-if="createView != -1">
      <div class="modal-body">
        <h2>Create a new view</h2>
        <!--<p>Name</p>                                                             TODO
        <input type="text" class="btn" placeholder="Name">-->
        <div class="action-panel">
          <div class="btn" v-on:click="createView = -1">Cancel</div>
          <div class="btn main" v-on:click="createViewFunction('New view')">Add</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
}
.view {
  margin-bottom: 1.5rem;
  &:last-child{
    margin-bottom: 0;
  }
  border-radius: 5px;
  background-color: var(--bg-color-2);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  padding: 1rem;
  h2 {
    margin-top: 0;
  }
  h3 {
    margin: 0 0 10px 0;
  }
  .devices {
    display: flex;
    &>div{
      display: flex;
    }
    span {
      margin: 0 10px 0 0;
      padding: 5px 8px;
      border-radius: 5px;
      background-color: var(--bg-color-3);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      user-select: none;
    }
  }
  .button-line{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  }
  .split {
    display: flex;
    & > *:first-child {
      flex-grow: 2;
    }
  }
}
.addView{
  border-radius: 5px;
  background-color: var(--bg-color-2);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  padding: 1rem;
  margin-top:  1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  user-select: none;
  cursor: pointer;
  transition: background-color 300ms ease, box-shadow 300ms ease;
  &:hover{
    background-color: var(--bg-color-3);
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);

  }
}
select.btn {
  width: 100%;
}
</style>
<script>
export default {
  name: "Overview",
  data() {
    return {
      views: [],
      addDeviceTo: -1,
      deviceToBeAdded: null,
      removeDeviceFromView:{
        device: -1,
        view: -1
      },
      deleteView: null,
      createView: -1,
    };
  },
  methods: {
    getViews: function() {
      this.$socket.client.emit("getViews", null, (error, response) => {
        if (error == "200") {
          this.views = response;
        }
      });
    },
    saveView: function(view){
      this.$socket.client.emit("saveView", {devices: view.devices, public:view.public, uuid:view.uuid}, (error, response) => {
        if (error == "200") {
            document.getElementById("Toast1").classList.remove("red");
            document.getElementById("Toast1").classList.remove("hide");
            document.getElementById("Toast1").classList.add("green");
            document.getElementById("Toast1").innerText = "Changes was saved";
            setTimeout(function() {
                document.getElementById("Toast1").classList.add("hide");
            }, 3000);
        }else{
            console.log(response);
        }
      });
    },
    deleteViewFunction: function(viewuuid){
      this.$socket.client.emit("deleteView", viewuuid, (error, response) => {
        if (error == "200") {
            this.deleteView = null;
            this.getViews();
            document.getElementById("Toast1").classList.remove("red");
            document.getElementById("Toast1").classList.remove("hide");
            document.getElementById("Toast1").classList.add("green");
            document.getElementById("Toast1").innerText = "View deleted";
            setTimeout(function() {
                document.getElementById("Toast1").classList.add("hide");
            }, 3000);
        }else{
            console.log(response);
        }
      });
    },
    createViewFunction: function(data){
      this.$socket.client.emit("createView", data, (error, response) => {
        if (error == "200") {
            this.createView = -1;
            this.getViews();
            document.getElementById("Toast1").classList.remove("red");
            document.getElementById("Toast1").classList.remove("hide");
            document.getElementById("Toast1").classList.add("green");
            document.getElementById("Toast1").innerText = "view created";
            setTimeout(function() {
                document.getElementById("Toast1").classList.add("hide");
            }, 3000);
        }else{
            console.log(response);
        }
      });
    },
    addDeviceToView: function() {
      var view = this.views.find(view => {
        return view.uuid == this.addDeviceTo;
      })
        if(view.devices != ''){
            view.devices += "," + this.deviceToBeAdded;
        }else{
            view.devices = ""+this.deviceToBeAdded;
        }
      this.saveView(view);
      this.addDeviceTo = -1;
    },
    removeDeviceFromViewFunction: function(){
      var devices = this.views.find(view => {
        return view.uuid == this.removeDeviceFromView.view;
      }).devices;
      devices = devices.split(',');
      var newDevices = [];
      for(var i = 0; i < devices.length; i++){
        if(devices[i] != this.removeDeviceFromView.device){
          newDevices[newDevices.length] = devices[i];
        }
      }
      var view = this.views.find(view => {
        return view.uuid == this.removeDeviceFromView.view;
      })
      
      view.devices = newDevices.join(',');
      this.saveView(view);

      this.removeDeviceFromView.view = -1;
      this.removeDeviceFromView.device = -1;
    }
  },
  mounted() {
    this.getViews();
  }
};
</script>